module.exports = __webpack_public_path__ + "static/media/ds_from_scratch.afd0f72a.png";